import { APIClientBase } from "./APIClientBase";
/**
 * Factory for creating API clients
 */
export class APIClientFactory {
    /**
     * Create an API client
     * @param baseUrl - The base URL for API requests
     * @param authService - The authentication service
     * @param fetchImpl - The fetch implementation to use
     * @returns An API client
     */
    static create(baseUrl, authService, fetchImpl) {
        // If fetch implementation is not provided, try to use the environment's default
        if (!fetchImpl) {
            // Check if we're in a browser environment
            const isBrowser = typeof window !== "undefined";
            if (isBrowser && window.fetch) {
                // Use browser's native fetch
                fetchImpl = window.fetch.bind(window);
            }
            else {
                // In Node.js, the consumer must provide a fetch implementation
                throw new Error("APIClientFactory: No fetch implementation provided. In Node.js environments, " +
                    "you must provide a fetch implementation (e.g., node-fetch).");
            }
        }
        return new APIClientBase(baseUrl, authService, fetchImpl);
    }
}
